var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"toast-class",class:`${_vm.variant} ${_vm.classAnimation}`,on:{"click":function($event){return _vm.handdlerToast()}}},[_c('InfoIcon',{staticClass:"mr-2"}),_c('div',{staticClass:"d-block no-break"},[_c('span',[_vm._v(_vm._s(_vm.message))]),_c('br'),_c('span',[_vm._v(_vm._s(_vm.message1))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }